import React from "react";
import {Query} from "react-apollo";
import MarketplaceUnreadCountQuery from "../../queries/MarketplaceUnreadCountQuery";
import {useMarketplaceConfig} from "../../../MarketplaceConfigProvider";

export default function InboxUnreadCountQuery({render}) {
    const {marketplace} = useMarketplaceConfig();
    return (
        <Query
            query={MarketplaceUnreadCountQuery}
            variables={{
                marketplaceSlug: marketplace.slug,
            }}
            asyncMode
            pollInterval={60000}
        >
            {({data, error, loading}) => {
                if (loading || error) {
                    return render({count: 0});
                }
                return render({count: data.marketplaceUnreadMessageCount});
            }}
        </Query>
    );
}
